import {
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItemDivider,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
  useIonAlert,
  useIonViewWillEnter,
} from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetDocumentList,
  setMassiveSignStatus,
  setShowMassiveSign,
  setShowModalToSignMassive,
} from "../../store/documentsSignerList";
import { fetchDocuments } from "../../store/documentsSignerList/actions/fetchDocuments";
import { DocumentCount } from "./components/DocumentCount";
import { DocumentsListSection } from "./components/DocumentsListSection";
import { FilterCreatedAtSelector } from "./components/FilterCreatedAtSelector";
import { FilterCreatedBySelector } from "./components/FilterCreatedBySelector";
import { FilterSection } from "./components/FilterSection";
import { FilterStatusSelector } from "./components/FilterStatusSelector";
import { FilterTypeSelector } from "./components/FilterTypeSelector";
import { HelperActions } from "./components/HelperActions";
import { SearchTextInput } from "./components/SearchTextInput";
import { SegmentSelector } from "./components/SegmentSelector";
import { SignMassiveToolbar } from "./components/SignMassiveToolbar";
import { SortSelector } from "./components/SortSelector";
import { ViewModeSelector } from "./components/ViewModeSelector";
import { selectShowModalToSignMassive } from "../../store/documentsSignerList/selectors/selectShowModalToSignMassive";
import { selectCheckedDocumentsCount } from "../../store/documentsSignerList/selectors/selectCheckedDocumentsCount";
import { selectSignerDocuments } from "../../store/documentsSignerList/selectors/selectSignerDocuments";
import { signDocument } from "../../store/documentsSignerList/actions/signDocument";
import { useEffect } from "react";

export const SignerDocumentList = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const checkedDocumentsCount = useSelector(selectCheckedDocumentsCount);
  const showModalToSignMassive = useSelector(selectShowModalToSignMassive);
  const selectedDocuments = useSelector(selectSignerDocuments).filter(({ checked }) => checked);

  useIonViewWillEnter(() => {
    dispatch(resetDocumentList());
    dispatch(fetchDocuments());
  });

  const handleSignAll = async () => {
    dispatch(setMassiveSignStatus("pending"));
    for (const document of selectedDocuments) {
      try {
        await dispatch(signDocument(document));
      } catch (error) {
        console.log(error);
      }
    }
    dispatch(setMassiveSignStatus("fulfilled"));
  };

  const handleCancelSignMassive = () => {
    dispatch(setShowMassiveSign(false));
    dispatch(setShowModalToSignMassive(false));
  };

  useEffect(() => {
    if (showModalToSignMassive && selectedDocuments.length > 0) {
      present({
        header: `¿Deseas firmar ${checkedDocumentsCount} ${
          checkedDocumentsCount === 1 ? "acuerdo" : "acuerdos"
        } digitalmente?`,
        message: "Al firmar los acuerdos estoy aceptando la veracidad de su contenido.",
        buttons: [
          // "No",
          {
            text: "No",
            handler: () => handleCancelSignMassive(),
          },
          {
            text: `Firmar ${checkedDocumentsCount} ${
              checkedDocumentsCount === 1 ? "acuerdo" : "acuerdos"
            }`,
            handler: () => handleSignAll(),
          },
        ],
      });
    }
  }, [showModalToSignMassive, selectedDocuments]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light" />
          </IonButtons>

          <IonTitle>Mis acuerdos</IonTitle>

          <IonButtons slot="end">
            <HelperActions />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Mis acuerdos</IonTitle>
          </IonToolbar>
        </IonHeader>
        <br />

        <IonGrid className="ion-margin-horizontal">
          <IonRow>
            <IonCol>
              <SegmentSelector />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid className="ion-padding-horizontal">
          <IonRow>
            <IonCol size="12" sizeMd="8" sizeLg="6">
              <SearchTextInput />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid className="ion-padding-horizontal">
          <IonRow class="ion-align-items-center">
            <IonCol size="auto" style={{ display: "flex" }}>
              <FilterSection />
            </IonCol>
          </IonRow>
        </IonGrid>

        <section className="ion-padding-horizontal">
          <IonItemDivider>
            <IonLabel>
              <h2>
                <DocumentCount />
              </h2>
            </IonLabel>
            <IonButtons slot="end">
              <SortSelector />
              <ViewModeSelector />
            </IonButtons>
          </IonItemDivider>
        </section>

        <DocumentsListSection />

        <FilterCreatedBySelector />
        <FilterTypeSelector />
        <FilterStatusSelector />
        <FilterCreatedAtSelector />
      </IonContent>
      <SignMassiveToolbar />
    </IonPage>
  );
};
export {};
